import knifeMakerDefaultState from '~src/store/preloaded-state'
import {
  CompletedStepsActionPayload,
  WizardActionName,
  WizardActionTypes,
} from '~src/types/actions/wizard-actions'
import { Wizard } from '~src/types/types-store'
import { StepPath } from '~src/types/wizard'

const getCompletedSteps = (
  validSteps: StepPath[],
  { isCurrentStepValid, currentStepPath }: CompletedStepsActionPayload
): StepPath[] => {
  const updatedCompletedSteps = isCurrentStepValid
    ? [...validSteps, currentStepPath]
    : validSteps.filter((step): boolean => step !== currentStepPath)

  return Array.from(new Set(updatedCompletedSteps)) as StepPath[]
}

const wizardReducer = (
  state = knifeMakerDefaultState.wizard,
  action: WizardActionTypes
): Wizard => {
  switch (action.type) {
    case WizardActionName.TOGGLE_WIZARD_STEP:
      return {
        ...state,
        currentStepPath: action.newStepPath,
      }
    case WizardActionName.SET_COMPLETED_STEPS:
      return {
        ...state,
        validSteps: getCompletedSteps(state.validSteps, action.payload),
      }
    default:
      return state
  }
}

export { wizardReducer }
